import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { ViewProps } from 'approot/activity-builder/components/response/response.constants';
import { useResponseBaseHeight } from 'approot/activity-builder/components/response/response.hooks';
import { useStudentGetAnswers } from '../../../student/answer/student-answer.hooks';
import { useBatchStudentAnswersContext } from '../../shared/batch-student-answer.context';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import SubActivityView from 'approot/activity-builder/components/sub-activity/sub-activity-view';
import ResponseViewField from '../response-view-field';
import * as Styled from '../response-view.style';
import ComponentLoading from '../../shared/component-loading';
import { ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE } from 'global/constants';
import { AnswerSaveStatus } from '../../shared/answer-save-status/answer-save-status';

const ResponseStudent = ({
  id,
  type,
  properties,
  subActivityProperties,
}: ViewProps) => {
  const baseHeight = useResponseBaseHeight();

  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );

  const { componentAnswers, variables, hasFetchedAnswers, error } =
    useStudentGetAnswers({
      componentId: id,
    });

  const { handleUpdate } = useBatchStudentAnswersContext();
  const { activeComponent, setActiveComponent } =
    useActivityBuilderPresentContext();

  const isActive = activeComponent?.id === id;

  return subActivityProperties?.activityComponentId ? (
    <SubActivityView
      subActivityDetails={subActivityProperties}
      componentId={id}
      componentType={type}
      onClick={() => setActiveComponent({ id })}
    >
      <Styled.ResponseViewContainer>
        {sortedFields.map(field => {
          const answer = componentAnswers?.find(
            a => a.answerReferences?.id === field.itemId
          );
          return (
            <Styled.ResponseFieldWrapper key={field.itemId}>
              {isActive && activeComponent?.itemId === field.itemId && (
                <AnswerSaveStatus />
              )}

              <ResponseViewField
                key={field.itemId}
                updateAnswer={input => {
                  if (variables) {
                    handleUpdate({
                      input,
                      variables,
                      dataTrackingComponentType:
                        ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
                    });
                  }
                }}
                answer={answer}
                baseHeight={baseHeight}
                field={field}
                componentId={id}
                activityId={subActivityProperties?.activityComponentId}
                onFocus={() =>
                  setActiveComponent({ id }, { itemId: field.itemId })
                }
              />
              <ComponentLoading hasData={hasFetchedAnswers} error={error} />
            </Styled.ResponseFieldWrapper>
          );
        })}
      </Styled.ResponseViewContainer>
    </SubActivityView>
  ) : null;
};

export default ResponseStudent;
